import { trackEvent } from '../MatomoUtils';
import { CameraMode } from '@egr/wcf/modules/core/view';

export function trackCameraSwitch(camera: CameraMode): void {
    let name: '2D' | '3D' | 'Orthographic' | 'Perspective' | 'Top' | 'Bottom' | 'Left' | 'Right' | 'Front' | 'Back' | undefined;

    switch (camera) {
        case CameraMode.Orthographic:
            name = 'Orthographic';
            break;
        case CameraMode.Perspective:
            name = 'Perspective';
            break;
        case CameraMode.Top:
            name = 'Top';
            break;
        case CameraMode.Bottom:
            name = 'Bottom';
            break;
        case CameraMode.Left:
            name = 'Left';
            break;
        case CameraMode.Right:
            name = 'Right';
            break;
        case CameraMode.Front:
            name = 'Front';
            break;
        case CameraMode.Back:
            name = 'Back';
            break;
        default:
            return;
    }

    trackEvent({
        category: 'Camera',
        action: 'switch',
        name,
    });
}
